package hk.com.vr360_demo2.webapp.component.dialog

import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML.span
import web.cssom.Color
import web.cssom.px
import web.cssom.WhiteSpace

external interface DialogContentTextProps : Props {
    var text: String
}

val DialogContentText = FC<DialogContentTextProps> { props ->
    span {
        css {
            fontSize = 14.px
            whiteSpace = WhiteSpace.preLine
            color = Color("#222")
            lineHeight = 30.px
        }
        +props.text
    }
}
